import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common';
import { Club } from '../club/club';

@Injectable()
export class UserProvider {

  constructor(public http: HttpClient, private commonService: CommonProvider) {}

  private _url: string = `${this.commonService.apiUrl}api/v1/user`;
  
  getAll(): Observable<Response<User[]>> {
    return this.http.get<Response<User[]>>(this._url + '/list');
  }

  get(id: string): Observable<Response<User>> {
    return this.http.get<Response<User>>(this._url + `/${id}/showmobile`);
  }

  getCurrentUser(): Observable<Response<User>> {
    return this.http.get<Response<User>>(`${this._url}/current`);
  }

  update(id: string, user: UserUpdate): Observable<Response<User>> {
    return this.http.post<Response<User>>(this._url + `/${id}/update`, user);
  }

  delete(user: User | string): Observable<Response<User>> {
    const id = typeof user == 'string' ? user : user.id;
    return this.http.post<Response<User>>(this._url + `/${id}/delete`, null);
  }

  getPosts(): Observable<Response<any[]>> {
    return this.http.get<Response<any[]>>(this._url + '/post/list');
  }

  getClubs(): Observable<Response<Club[]>> {
    return this.http.get<Response<Club[]>>(this._url + '/club/list');
  }

}

export interface User {
  id: string;
  company_id?: string;
  avatar_id?: string;
  last_name?: string;
  first_name?: string;
  phone?: string;
  email?: string;
  birth_date?: number;
  position?: string;
  qualifications?: string;
  country?: string;
  postal_code?: string;
  description?: string;
  contact_email?: string;
  linkedin_link?: string;
  gender?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

export interface UserUpdate {
  last_name: string;
  first_name: string;
  position: string;
  description: string;
  contact_email: string;
  avatar: string;
  linkedin_link:string;
}


// WEBPACK FOOTER //
// ./src/providers/user/user.ts